// Generated from SVG to Code Figma Plugin

export const BaseLineQuestion = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.0004 21.5999C17.3023 21.5999 21.6004 17.3018 21.6004 11.9999C21.6004 6.69797 17.3023 2.3999 12.0004 2.3999C6.69845 2.3999 2.40039 6.69797 2.40039 11.9999C2.40039 13.3015 2.65943 14.5427 3.12878 15.6745C3.3711 16.2589 3.66949 16.8142 4.01724 17.3336C4.13394 17.508 3.915 18.61 3.36039 20.6399C5.39026 20.0853 6.49234 19.8663 6.66668 19.9831C7.18613 20.3308 7.7414 20.6292 8.3258 20.8715C9.45764 21.3408 10.6988 21.5999 12.0004 21.5999Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.44"
    />
    <path
      d="M8.30273 9.91016H16.6924"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M10.9236 7.86914L9.4668 16.1313"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M14.4236 7.86914L12.9668 16.1313"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M7.30273 14H15.6924"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
